<div *ngIf="spinnerState$ | async" class="spinner-overlay">
    <div class="spinner"></div>
</div>
